import {
    constructRequestEntityStandard,
    createData,
    createFormData,
    sanitizePayload,
    serializeEntityStandard
} from "./dataUtils";
import { resolveStaticBinding } from "./bindingUtils";
import {
    extractStorePath,
    findInWidgetState,
    getDependentPaths,
    getEntityPath,
    getUiStatePath
} from "./storeUtils";
import getWindowSize from "./windowSize";
import { getEntityId } from "./getEntityId";
import containerUtils, {
    buildEnumData,
    dispatchSirenActions,
    getEmptyContent,
    resolveBinding,
    resolveChild,
    resolveChildren,
    resolveCollectionItems,
    resolveRegions,
    saveState,
    setDataInStore
} from "./containerUtils";
import { getDataTqId } from "../utils/testIdUtils";

export default {
    createFormData,
    createData,
    constructRequestEntityStandard,
    resolveStaticBinding,
    findInWidgetState,
    getDependentPaths,
    extractStorePath,
    getEntityPath,
    getWindowSize,
    getEntityId,

    extractComponentProps: containerUtils.extractComponentProps,
    setDataInStore,
    getEmptyContent,
    resolveBinding,
    resolveChild,
    resolveChildren,
    resolveRegions,
    resolveCollectionItems,
    dispatchSirenActions,
    saveState,
    buildEnumData,

    getDataTqId,
    getUiStatePath,
    serializeEntityStandard,
    serialize: sanitizePayload
};
